export const GoogleMapApiConfig = 'AIzaSyBgtXHZO-AZWMU-4RWR--OZNsF8vPF7gZg';
